"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _View = _interopRequireDefault(require("@gogame/ui/View"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LoadingOverlay = function LoadingOverlay(_ref) {
  var fetching = _ref.fetching;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    style: {
      height: '100%'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_View["default"], {
      loading: !fetching,
      fetching: fetching
    })
  });
};
var _default = exports["default"] = LoadingOverlay;